import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M12 4.4a7.6 7.6 0 1 0 0 15.2 7.6 7.6 0 0 0 0-15.2ZM12 21a9 9 0 0 1-9-9 9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9Z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M9.281 10.173c0-1.496 1.23-2.687 2.719-2.687 1.49 0 2.718 1.193 2.718 2.688 0 1.17-.771 1.783-1.312 2.142-.468.31-.707.567-.707 1.006v.248a.7.7 0 1 1-1.4 0v-.248c0-1.185.78-1.807 1.334-2.173.456-.303.685-.552.685-.975 0-.702-.58-1.288-1.318-1.288-.739 0-1.319.586-1.319 1.287a.7.7 0 0 1-1.4 0ZM11.165 15.869a.81.81 0 1 1 1.625-.004.812.812 0 0 1-1.625.004Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
